<template>
  <div>
    <LazyDiscoverHeader />
    <LazyDiscoverActivities
      class="container addition-layout-padding mt-[24px] md:mt-[50px]"
      :facets="discoverFacets"
      :is-supplier="true"
    />
    <div v-if="faq.length" class="mt-[100px] container">
      <LazyDiscoverFaq :faq-items="faqItems" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { useAsyncData } from "nuxt/app";
import type { IFaqItem } from "../../../types/general";

type IFaq = { question: string; answer: string };

const config: any = useRuntimeConfig();
const { data: discoverFacets } = await useAsyncData<any>("facets", () =>
  customFetch(`api/v2/products/facets`)
);
const faq: IFaqItem[] | [] = (config.public.statics.faq as IFaqItem[]) ?? [];
let faqItems: IFaq[] | [] =
  faq.map((val: IFaqItem) => ({
    question: val.title,
    answer: val.content,
  })) ?? [];
</script>
